export const convertFieldToJqlTerm = (fieldName: string): string => {
	// custom fields are indexed by their ids and only work with JQL when referenced as such `cf[id]`.
	// fieldName match regex for customfield_<number> exactly
	// legacy gadget may have it stored as customfield_<number> in user prefs
	if (/^customfield_\d+$/.test(fieldName)) {
		const customFieldId = fieldName.split('customfield_')[1];
		return `cf[${customFieldId}]`;
	}

	return fieldName;
};
